import * as ng from 'angular';
import * as Linq from 'linq-es5';

import { ComponentRegistration } from '../../core';
import { ContentTypeSettingKeys } from '../../data/interfaces';
import { IContentTemplateResource } from '../../data/content-template'

let template = require('./faq.html');


class FaqComponent extends ComponentRegistration {

    constructor() {
        super('faq', {
            controller: FaqController,
            templateUrl: template,
            controllerAs: 'faq',
            bindings: {
            }
        });
    }
}

interface IFaqController {
    activate(): void;
}

class FaqController implements IFaqController {
    private static $inject: Array<string> = ['ContentTemplate'];

    public content: string;

    private key: string = ContentTypeSettingKeys[ContentTypeSettingKeys.FAQ];
    private language: string = 'en';

    constructor(private ContentTemplate: IContentTemplateResource) {
        console.log('FaqController loading');

        this.activate();
    }

    public activate(): void {
        console.log('FaqController loaded');

        this.ContentTemplate.query({ key: this.key, languageCode: this.language }).$promise
            .then((response) => {
                let template = Linq.From(response).FirstOrDefault();
                this.content = template.content;
            })
            .catch((e) => {
                console.log(e);
            });    
    }
}

let fqComponent = new FaqComponent();
export default fqComponent;
export { fqComponent as FaqComponent, IFaqController, FaqController }


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/components/public/faq.ts